import { Grid } from '@material-ui/core';
import React from 'react';
import { styles } from './checkout-area-styles';
import CustomerLoyalty from '../customer-loyalty/components/customer-loyalty';
import ItemList from '../item-list/item-list';
import TotalWrapper from '../total/components/total-wrapper';
import { AppState } from 'src/common/redux/configure-store';
import { useSelector } from 'react-redux';
import { IElectronicJournalRecord } from 'src/common/interfaces/states/IElectronicJournalRecord';
import { EJRecordTypes } from 'src/common/enumerations/ej-record-types';
import ReturnsTotal from '../returns/components/return-mode-total';
import TBRTotal from '../returns/components/tbr-total-container';
import { ReturnsType } from 'src/transaction-search/interfaces/get-effective-return-policy-response';

export interface CheckoutAreaProps {
  isCustomerDisplay?: boolean;
}

const CheckoutArea: React.FC<CheckoutAreaProps> = ({
  isCustomerDisplay,
}: CheckoutAreaProps): JSX.Element => {
  const classes = styles();
  const ejItems = useSelector(
    (state: AppState): IElectronicJournalRecord[] => state.itemList.ejItems,
  );
  const isTBRActive = useSelector(
    (state: AppState): boolean =>
      state.posMode.returnMode.returnType === ReturnsType.TransactionBasedReturn,
  );
  const hasProductItem = ejItems.filter(i => i.Type === EJRecordTypes.Product).length > 0;
  const hasReturnItem = ejItems.filter(i => i.Type === EJRecordTypes.ReturnItem).length > 0;

  return (
    <Grid container direction='column' className={classes.container} wrap='nowrap'>
      <Grid item className={`fullWidth ${classes.customerLoyalty}`}>
        <CustomerLoyalty isCustomerDisplay={isCustomerDisplay} />
      </Grid>
      <Grid
        item
        className={`${classes.itemListWrapper} ${
          hasProductItem && hasReturnItem ? classes.itemListSaleMode : ''
        }`}
      >
        <ItemList isCustomerDisplay={isCustomerDisplay} />
      </Grid>
      {isTBRActive ? (
        <Grid item className={`fullWidth ${classes.totalSaleMode}`}>
          <TBRTotal />
        </Grid>
      ) : hasProductItem && hasReturnItem ? (
        <Grid item className={`fullWidth ${classes.totalSaleMode}`}>
          <ReturnsTotal />
        </Grid>
      ) : (
        <Grid item className={`fullWidth ${classes.total}`}>
          <TotalWrapper isCustomerDisplay={isCustomerDisplay} />
        </Grid>
      )}
    </Grid>
  );
};

export default CheckoutArea;
